// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-y: hidden !important;
}

.amy-top-nav {
  display: initial !important;
}

@media only screen and (min-width: 768px) {
  .screen-space {
    padding-right: 4%;
  }
}
@media only screen and (max-width: 600px) {
  .body-padding {
    padding: 0px !important;
  }
  .mob-logo {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/ui/settings/secondary-header.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE;IACE,iBAAA;EACF;AACF;AAEA;EACE;IACE,uBAAA;EAAF;EAEA;IACE,aAAA;EAAF;AACF","sourcesContent":["body {\n  overflow-y: hidden !important;\n}\n\n.amy-top-nav {\n  display: initial !important;\n}\n\n@media only screen and (min-width: 768px) {\n  .screen-space {\n    padding-right: 4%;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .body-padding {\n    padding: 0px !important;\n  }\n  .mob-logo {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
